module.exports = __webpack_public_path__ + "static/media/logo_massanassa.e5cde3ae.png";